import React, {Component} from 'react';
import ContainerComponent from "../../components/container/ContainerComponent";
import SingleContainerComponent from "../../components/container/SingleContainerComponent";
import DetailNameComponent from "../../components/detail/DetailNameComponent";
import MUIRichTextEditor from "mui-rte";
import {ContentState, convertToRaw} from "draft-js";
import htmlToDraft from "html-to-draftjs";
import {Row} from "simple-flexbox";
import DetailSubTitleComponent from "../../components/detail/DetailSubTitleComponent";
import {Col, Row as BootstrapRow} from "react-bootstrap";
import FormContainer from "../../components/container/FormContainer";
import {Field, reduxForm} from "redux-form";
import {
    renderDatepicker,
    renderFile,
    renderInput,
    RenderInputCurrency,
    renderSelect
} from "../../components/form/FormComponent";
import {css, StyleSheet} from "aphrodite";
import {listCity} from "../../actions/master-data/city_action";
import {connect} from "react-redux";
import { withRouter } from "react-router-dom";
import { provinceList } from "../../actions/master-data/province_action";
import {
    getJobSpot,
    getJobSpotError,
    getJobSpotPending
} from "../../reducers/jobspot/jobspot";
import {getCityList} from "../../reducers/master-data/city_reducer";
import {getProvinceList} from "../../reducers/master-data/province_reducer";
import Button from "@material-ui/core/Button";
import ClearIcon from "@material-ui/icons/Clear";
import CheckIcon from "@material-ui/icons/Check";
import {history} from "../../helpers/history";
import moment from "moment";
import {addJobSpot} from "../../actions/jobspot/jobspot_action";
import {saveRichText} from "../../helpers/utils";
import {Save} from "@material-ui/icons";

class AddJobSpot extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isEdit: false,
            isEditFile: false,
            selectedItem: "pengantar",
            modalDetailPhotoShow: false,
            typeJobOptions: [
                {label: "Spesialis", value: "Spesialis"},
                {label: "Subspesialis", value: "Subspesialis"},
            ],
            contractOptions: [
                {label: "Fulltime", value: "Fulltime"},
                {label: "Parttime", value: "Parttime"},
            ],
            data: "",
            desc_error: false,
            html: "",
        };
        this.tableRef = React.createRef();


        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleErrors = this.handleErrors.bind(this);
    }
    componentDidMount() {
        const { provinceList } = this.props;
        provinceList({length: 10});
    }

    handleCancel(){
        history.push("/jobspot");
    }

    handleSave(data) {
        const rte = saveRichText(data);
        this.setState({
            html: rte,
        })
    };

    handleErrors(){
        const { html } = this.state;
        this.setState({
            desc_error: html === "<p></p>\n",
        })
    }

    async handleSubmit(values) {
        await this.handleErrors();
        const { addJobSpot } = this.props;
        const { html, desc_error } = this.state;

        let registration_start_date = values?.registration_start_date;
        let registration_end_date = values?.registration_end_date;

        let param = {
            ...values,
            instance_logo: values.instance_logo || "",
            contract: values?.contract?.value || "",
            type_job: values?.type_job?.value || "",
            city: values.city?.value || "",
            province: values.province?.value || "",
            salary_start_range: values?.salary_start_range?.replace(/[^0-9]/g, ''),
            salary_end_range: values?.salary_end_range?.replace(/[^0-9]/g, ''),
            registration_start_date: registration_start_date ? moment(registration_start_date).format("DD-MM-YYYY") : "",
            registration_end_date: registration_end_date ? moment(registration_end_date).format("DD-MM-YYYY") : "",
            published_start_date: moment(values?.published_start_date).format("DD-MM-YYYY"),
            published_end_date: moment(values?.published_end_date).format("DD-MM-YYYY"),
            description: html,
        };

        const callback = () => {
            history.push("/jobspot");
        };

        !desc_error && addJobSpot(param, callback);
    }

    render() {
        const {
            listCity_data,
            listProvince_data,
            listCity,
            handleSubmit,
            initialValues,
            change
        } = this.props;

        const {
            typeJobOptions,
            contractOptions,
            desc_error,
            html,
            selectedProvince
        } = this.state;

        let cityOptions = [],
            provinceOptions = [];


        const handleCityChange = (state) => {
            this.setState({selectedProvince: state})
            listCity({length: !state ? 0 : 10, province_id: state?.value || ""});
        }

        if(listCity_data && listCity_data.data.length !== 0){
            cityOptions = listCity_data.data.map((item) => ({
                label: item.name,
                value: item.city_id,
            }));
        }

        if (listProvince_data && listProvince_data.length !== 0) {
            provinceOptions = listProvince_data.map((item) => ({
                label: item.name,
                value: item.province_id,
            }));
        }

        let introduction = html || '';
        const blocksFromHtml = htmlToDraft(introduction);
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = JSON.stringify(
            convertToRaw(ContentState.createFromBlockArray(contentBlocks, entityMap))
        );

        return (
            <ContainerComponent>
                <SingleContainerComponent>
                    <form
                        onSubmit={handleSubmit(this.handleSubmit)}
                        style={{width: "100%"}}
                    >
                        <Row
                            vertical="center"
                            horizontal="space-between"
                            style={{ width: "100%", marginBottom: 20 }}
                        >
                            <DetailNameComponent name="Tambah Lowongan" />
                        </Row>
                        <DetailSubTitleComponent title="Informasi Pekerjaan"/>
                        <BootstrapRow lg={2}>
                            <Col md={12}>
                                <FormContainer mandatory label="Nama Pekerjaan">
                                    <Field
                                        name="name"
                                        placeholder="Masukkan Nama Pekerja"
                                        component={renderInput}
                                    />
                                </FormContainer>
                                <FormContainer label="Jenis">
                                    <Field
                                        name="type_job"
                                        placeholder="Masukkan Jenis"
                                        options={typeJobOptions}
                                        component={renderSelect}
                                    />
                                </FormContainer>
                            </Col>
                            <Col md={12}>
                                <FormContainer mandatory label="Kontrak Kerja">
                                    <Field
                                        name="contract"
                                        placeholder="Masukkan Kontrak Kerja"
                                        options={contractOptions}
                                        component={renderSelect}
                                    />
                                </FormContainer>
                            </Col>
                        </BootstrapRow>
                        <DetailSubTitleComponent title="Informasi Perusahaan"/>
                        <BootstrapRow lg={2}>
                            <Col md={12}>
                                <FormContainer mandatory label="Instansi">
                                <Field
                                    name="instance"
                                    placeholder="Masukkan instansi"
                                    component={renderInput}
                                />
                            </FormContainer>
                            </Col>
                            <Col md={12}>
                                <FormContainer label="Logo Instansi">
                                        <div>
                                            <Field
                                                name="instance_logo"
                                                type="file"
                                                fileType="image"
                                                title="Upload"
                                                component={renderFile}
                                            />
                                            <span style={{float: "right"}}>(Max File 1 MB)</span>
                                        </div>
                                </FormContainer>
                            </Col>
                        </BootstrapRow>

                        {/*Divider*/}
                        <DetailSubTitleComponent title="Lokasi Pekerjaan"/>
                        <BootstrapRow lg={2}>
                            <Col md={12}>
                                <FormContainer label="Jalan">
                                    <Field
                                        name="address"
                                        placeholder="Masukkan jalan"
                                        component={renderInput}
                                    />
                                </FormContainer>
                                <FormContainer mandatory label="Provinsi">
                                    <Field
                                        options={provinceOptions}
                                        name="province"
                                        placeholder="Pilih provinsi"
                                        isAsync
                                        type="province"
                                        asyncUrl="master_data/data_reference/find_province"
                                        onChange={(state) => {
                                            if(!state){
                                                change("city", null);
                                                handleCityChange(null);
                                            }else{
                                                handleCityChange(state)
                                            }
                                        }}
                                        component={renderSelect}
                                    />
                                </FormContainer>
                            </Col>
                            <Col md={12}>
                                <FormContainer mandatory label="Kabupaten/Kota">
                                    <Field
                                        options={cityOptions}
                                        name="city"
                                        disabled={cityOptions.length < 1}
                                        isAsync
                                        type="city"
                                        customParams={{
                                            province_id: selectedProvince?.value,
                                            length: 10
                                        }}
                                        asyncUrl="master_data/data_reference/find_city"
                                        placeholder="Pilih Kabupaten/Kota"
                                        component={renderSelect}
                                    />
                                </FormContainer>
                                <FormContainer label="Kecamatan">
                                    <Field
                                        name="district"
                                        placeholder="Pilih kecamatan"
                                        component={renderInput}
                                    />
                                </FormContainer>
                            </Col>
                        </BootstrapRow>

                        {/*Divider*/}
                        <DetailSubTitleComponent title="Detail Lowongan "/>
                        <BootstrapRow lg={2}>
                            <Col md={12}>
                                <FormContainer label="Tanggal Pendaftaran">
                                    <div className={css(styles.flexBox)}>
                                        <div>
                                            <Field
                                                name="registration_start_date"
                                                component={renderDatepicker}
                                                isNotAutofill
                                                customFormat="DD MMMM YYYY"
                                            />
                                        </div>
                                        <div> - </div>
                                        <div>
                                            <Field
                                                name="registration_end_date"
                                                component={renderDatepicker}
                                                isNotAutofill
                                                customFormat="DD MMMM YYYY"
                                            />
                                        </div>
                                    </div>
                                </FormContainer>
                                <FormContainer mandatory label="Durasi Posting">
                                    <div className={css(styles.flexBox)}>
                                        <div>
                                            <Field
                                                name="published_start_date"
                                                component={renderDatepicker}
                                                isNotAutofill
                                                customFormat="DD MMMM YYYY"
                                            />
                                        </div>
                                        <div> - </div>
                                        <div>
                                            <Field
                                                name="published_end_date"
                                                component={renderDatepicker}
                                                isNotAutofill
                                                customFormat="DD MMMM YYYY"
                                            />
                                        </div>
                                    </div>
                                </FormContainer>
                            </Col>
                            <Col md={12}>
                                <FormContainer label="Gaji/Bulan">
                                    <div className={css(styles.flexBox)}>
                                        <div>
                                            <Field
                                                name="salary_start_range"
                                                component={RenderInputCurrency}
                                            />
                                        </div>
                                        <div> - </div>
                                        <div>
                                            <Field
                                                name="salary_end_range"
                                                component={RenderInputCurrency}
                                            />
                                        </div>
                                    </div>
                                </FormContainer>
                            </Col>
                        </BootstrapRow>

                        {/*Divider*/}
                        <DetailSubTitleComponent
                            isEdit
                            title="Deskripsi Lowongan"
                            mandatory
                            message={(
                                <>
                                    Catatan: Tekan ikon <Save/> di text editor (box deskripsi)
                                    sebelum menyimpan hasil perubahan.
                                </>
                            )}
                            error={desc_error}
                        />
                            <MUIRichTextEditor
                                onSave={this.handleSave}
                                ref={this.tableRef}
                                controls={[
                                    "title",
                                    "bold",
                                    "italic",
                                    "underline",
                                    "strikethrough",
                                    "undo",
                                    "redo",
                                    "link",
                                    "clear",
                                    "link",
                                    "save"
                                ]}
                                defaultValue={contentState}
                            />
                        <Row
                            horizontal="flex-end"
                            vertical="center"
                            style={{ width: "100%", marginTop: 20 }}
                        >
                            <Button
                                variant="contained"
                                color="primary"
                                className={css(styles.rejectButton)}
                                startIcon={<ClearIcon />}
                                onClick={() => this.handleCancel()}
                            >
                                Batal
                            </Button>
                            <Button
                                variant="contained"
                                type="submit"
                                color="primary"
                                className={css(styles.approveButton)}
                                startIcon={<CheckIcon />}
                            >
                                Simpan
                            </Button>
                        </Row>
                    </form>
                </SingleContainerComponent>
            </ContainerComponent>
        );
    }
}

const styles = StyleSheet.create({
    flexBox:{
        display: "flex",
        alignItems: "center",
        gap: "1rem",
        justifyContent: "flex-start",
    },
    approveButton: {
        background: "#2CB96A 0% 0% no-repeat padding-box",
        boxShadow: "none",
    },
    rejectButton: {
        background: "#EAEBED 0% 0% no-repeat padding-box",
        marginRight: 10,
        color: "#495057",
        boxShadow: "none",
    },
});

function validate(values) {
    const {
        name,
        contract,
        instance,
        province,
        city,
        published_start_date,
        published_end_date,
    } = values;
    const errors = {};
    if (!name) {
        errors.name = "Nama Lowongan wajib diisi";
    }
    if (!contract) {
        errors.contract = "Kontrak Kerja wajib diisi";
    }
    if (!instance) {
        errors.instance = "Instansi wajib diisi";
    }
    if (!published_start_date) {
        errors.published_start_date = "Durasi Posting wajib diisi";
    }
    if (!published_end_date) {
        errors.published_end_date = "Durasi Posting wajib diisi";
    }
    if (!province) {
        errors.province = "Provinsi wajib diisi";
    }
    if (!city && !province) {
        errors.city = "Pilih provinsi terlebih dahulu";
    }
    if (!city && province) {
        errors.city = "Kabupaten/Kota wajib diisi";
    }

    return errors;
}

AddJobSpot = reduxForm({
    form: "JobSpotDetail",
    validate: validate,
    shouldError: () => true,
    enableReinitialize: true,
})(AddJobSpot);

function mapStateToProps({jobSpot, listCity, provinceList}) {

    return {
        listCity_data: getCityList(listCity),
        listProvince_data: getProvinceList(provinceList),
        jobSpotList_pending: getJobSpotPending(jobSpot),
        jobSpotList_data: getJobSpot(jobSpot),
        jobSpotList_error: getJobSpotError(jobSpot),
    };
}

export default connect(mapStateToProps, {
    listCity,
    provinceList,
    addJobSpot,
})(withRouter(AddJobSpot));